import React, { useState } from 'react';
import ChatWindow from './ChatWindow';

const ChatLauncher = ({ userId, username }) => {
  const [showChat, setShowChat] = useState(false);
  const [roomId, setRoomId] = useState('lobby_main');

  return (
    <>
      {/* Chat Button */}
      {!showChat && (
        <button
          onClick={() => setShowChat(true)}
          className="fixed bottom-4 right-4 w-16 h-16 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 rounded-full shadow-2xl flex items-center justify-center text-3xl transition-all transform hover:scale-110 z-50 animate-bounce"
          title="Open Chat"
        >
          💬
        </button>
      )}

      {/* Chat Window */}
      {showChat && (
        <ChatWindow
          roomId={roomId}
          userId={userId}
          username={username}
          onClose={() => setShowChat(false)}
        />
      )}
    </>
  );
};

export default ChatLauncher;